
export const ChromeWebStoreLink: string = 'https://chrome.google.com/webstore/detail/bamboo/emkbopnddoaamknefpmmkjjpikcnceoa';